import { initBottomCvArea, initSharedPageInteractions, syncChangedActionForm } from './shared_page_interactions'
import { initTailClamps } from './tail-clamp-init'
import './review-card-details'
import { bindCountedSelect } from './counted_select'
import { bindMunicipalitySelect } from './municipality_select'

export { initBottomCvArea, syncChangedActionForm }

export function initReviewFilterForms() {
  document.querySelectorAll('[data-review-filter-form]').forEach((form) => {
    if (form.dataset.reviewFilterInitialized === 'true') return

    bindMunicipalitySelect(form)
    form.querySelectorAll('[data-counted-select]').forEach((wrapper) => {
      const refresh = bindCountedSelect(wrapper)
      // 自身の変更は部品内で反映する。都道府県に連動する市区町村だけ追加で更新する。
      if (wrapper.querySelector('[data-municipality-select]')) {
        form.querySelector('[data-prefecture-select]')?.addEventListener('change', refresh)
      }
    })
    form.dataset.reviewFilterInitialized = 'true'
  })
}

export function initReformReviewArchive() {
  initSharedPageInteractions()
  initReviewFilterForms()
}

// htmx で追加した本文にも既存の折りたたみ処理を適用する。
document.addEventListener('htmx:afterSwap', (event) => initTailClamps(event.target))

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReformReviewArchive)
} else {
  initReformReviewArchive()
}
